import { Box, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddIcon from "@mui/icons-material/Add";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLoginContext } from "../../context/loginContextProvider";
import { useNavigate } from "react-router";

export type HeaderProps = {
  back?: boolean;
};

export const MobileHeader = ({ back }: HeaderProps) => {
  const { logout } = useLoginContext();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        py: 1,
      }}
    >
      {back && (
        <IconButton
          onClick={() => navigate(-1)}
          aria-label="Back"
          sx={{ ml: -1 }}
        >
          <ArrowBackIosIcon />
        </IconButton>
      )}

      <Box
        component="h2"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          m: 0,
          fontSize: "1.4rem",
          lineHeight: 1.2,
        }}
      >
        Crypto Dashboard
      </Box>

      <IconButton
        color="primary"
        aria-label="Add profile"
        onClick={() => navigate("/add-profile")}
      >
        <AddIcon />
      </IconButton>
      <IconButton aria-label="Logout" onClick={() => logout()}>
        <LogoutIcon />
      </IconButton>
    </Box>
  );
};
